import { render, staticRenderFns } from "./WpVariantProductListingSection.vue?vue&type=template&id=efede37c&scoped=true&"
import script from "./WpVariantProductListingSection.vue?vue&type=script&lang=js&"
export * from "./WpVariantProductListingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efede37c",
  null
  
)

export default component.exports